/**
 * Colors are represented in - rrggbbaa -
 * alpha = light opacity = 0.38 = 66
 * beta = medium opacity = 0.60 = 99
 * gamma = high opacity = 0.87 = E6
 */

const colors = {
  PRIMARY: '#FFA400FF',
  PRIMARY_LIGHT: '#FFCE7E',
  WHITE: '#FFFFFFFF',
  BLACK: '#000000FF',
  BLACK_APLHA: '#00000066',
  BLACK_BETA: '#00000099',
  BLACK_GAMMA: '#000000E6',
  LIGHT_BLUE: '#00A0DFFF',
  DARK_BLUE: '#004987FF',
  NAVY: '#003A64FF',
  MAJENTA: '#DB0032FF',
  ERROR: '#E02020FF',
  SUCCESS: '#6DD400FF',
  GOLDEN_BROWN: '#E08433FF',
  BORDER_LIGHT: '#EBEBEB',
  BORDER_MEDIUM: '#DFD9D9',
  GREY: '#737373',
  LIGHT_GREY: '#f5f4f8',
  PURE_BLUE: '#00a0df',
  LIGHT_GRAYISH_BLUE: '#E2E8F0',
  MUTED: '#F0F1F3',
  SECONDARY: '#036FCB',
  YELLOW: '#FB8900',
  BLUE: '#036FCB',
  RED: '#DB0032',
  ORANGE: '#F2994A',
  GREEN: '#148E3C',
  CRIMSON: '#DB0032',
  GREEN_G700: '#148E3C',
};

export default colors;
